/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IAddressButton {
    className: string;
    text: string;
    ariaLabel: string;
    disabled?: boolean;
    telemetryContent?: ITelemetryContent;
    onClick(event: React.MouseEvent<HTMLElement>): void;
}

const AddressButton: React.FC<IAddressButton> = ({ className, text, ariaLabel, disabled, telemetryContent, onClick }) => {
    const payLoad = getPayloadObject('click', telemetryContent!, text);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    return (
    <button
        className={className}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
        {...attributes}
    >
        {text}
    </button>);
};

export default AddressButton;
